/**
 * Summary stat cards for GET /dashboard (driven by `getDashboardSummaryCounts`).
 *
 * `cardLink` drives dashboard click targets: simple app routes or Work Items list with type filter.
 */

const BLUEPRINTS = [
  {
    title: "Clients",
    countKey: "clients",
    bg: "bg-dashboard-variant-2",
    iconPath:
      "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
    cardLink: { type: "path", to: "/clients" },
  },
  {
    title: "Projects",
    countKey: "projects",
    bg: "bg-dashboard-variant-1",
    iconPath: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4",
    cardLink: { type: "path", to: "/projects" },
  },
  {
    title: "Tasks",
    countKey: "tasks",
    bg: "bg-dashboard-variant-3",
    iconPath:
      "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z",
    cardLink: { type: "workItems", workItemType: "Task" },
  },
  {
    title: "Bugs",
    countKey: "bugs",
    bg: "bg-dashboard-variant-4",
    iconPath: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
    cardLink: { type: "workItems", workItemType: "Bug" },
  },
];

/**
 * @param {{ clients: number, projects: number, tasks: number, bugs: number }} counts
 * @returns {Array<{ title: string, value: number, bg: string, iconPath: string, cardLink: object }>}
 */
export function getDashboardStatsCards(counts) {
  if (!counts || typeof counts !== "object") {
    return BLUEPRINTS.map((b) => ({
      title: b.title,
      value: 0,
      bg: b.bg,
      iconPath: b.iconPath,
      cardLink: b.cardLink,
    }));
  }
  return BLUEPRINTS.map((b) => ({
    title: b.title,
    value: Number(counts[b.countKey]) || 0,
    bg: b.bg,
    iconPath: b.iconPath,
    cardLink: b.cardLink,
  }));
}
